import { Directive, EventEmitter, HostListener, Input, Output, HostBinding } from '@angular/core';

@Directive({
  selector: '[appFileUploader]'
})

export class FileUploaderDirective {
  background = '';
  @Input() private allowedExtensions: Array<string> = [];
  @Output() private filesChangeEmiter: EventEmitter<Array<File>> = new EventEmitter();
  @Output() private filesInvalidEmiter: EventEmitter<Array<File>> = new EventEmitter();

  @HostListener('drop', ['$event']) onDrop(e): void {
    e.preventDefault();
    e.stopPropagation();
    this.fileOver = false;
    const files = e.dataTransfer.files;
    const validFiles: Array<File> = [];
    const invalidFiles: Array<File> = [];
    if (files.length > 0) {
      for (const file of files) {
        const ext = file.name.split('.')[file.name.split('.').length - 1];
        if (
          (!this.allowedExtensions.length) ||
          (this.allowedExtensions.lastIndexOf(ext) !== -1)
        ) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file);
        }
      }
      if (validFiles.length > 0) {
        this.filesChangeEmiter.emit(validFiles);
      }
      if (invalidFiles.length > 0) {
        this.filesInvalidEmiter.emit(invalidFiles);
      }
    }
  }

  @HostListener('dragover', ['$event']) onDragOver(e): void {
    e.preventDefault();
    e.stopPropagation();
    this.fileOver = true;
  }

  @HostListener('dragleave', ['$event']) onDragLeave(e): void {
    e.preventDefault();
    e.stopPropagation();
    this.fileOver = false;
  }

  @HostBinding('class.fileover') fileOver: boolean;
}
